import { X } from 'lucide-react'
import { IconButton } from '@doculegis/shared'
import { cn } from '@/lib/utils'

interface CustomDataTagProps {
  label: string
  onRemove: () => void
  colorClass?: string
  className?: string
}

export function CustomDataTag({ label, onRemove, colorClass = 'blue', className }: CustomDataTagProps) {
  const colorMap: Record<string, string> = {
    blue: 'bg-blue-500/15 border-blue-500/30',
    green: 'bg-green-500/15 border-green-500/30',
    purple: 'bg-purple-500/15 border-purple-500/30',
    yellow: 'bg-yellow-500/15 border-yellow-500/30',
  }

  return (
    <span className={cn(
      "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs mr-1 mt-1 border",
      colorMap[colorClass] || colorMap.blue,
      className
    )}>
      {label}
      <IconButton
        type="button"
        size="xs"
        variant="destructive"
        onClick={onRemove}
        className="leading-none"
        aria-label={`Remove ${label}`}
      >
        <X className="h-3 w-3" />
      </IconButton>
    </span>
  )
}
